/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterStyle_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuMultiSelectList_itemSearch">;
    readonly " $refType": "SbSharedRefineMenuFilterStyle_itemSearch";
};
export type SbSharedRefineMenuFilterStyle_itemSearch$data = SbSharedRefineMenuFilterStyle_itemSearch;
export type SbSharedRefineMenuFilterStyle_itemSearch$key = {
    readonly " $data"?: SbSharedRefineMenuFilterStyle_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterStyle_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterStyle_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectList_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = 'a10949a6fd8ba751f4c7bbdbe059d77f';
export default node;
